<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah {{ label }}</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="kbli-modal-filter-search" style="padding: 0 10px">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i
                        class="fas fa-times"
                        style="cursor:pointer; marginRight: 10px"
                        @click="resetPlaceholder()"
                        v-if="subSearch.length !== '' && subSearch"
                      ></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input
                  type="text"
                  :placeholder="`Cari ${label}`"
                  v-model="subSearch"
                  @keyup="searchRun()"
                ></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-body" v-if="iujpData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column90 mr10">Bidang</div>
          </div>
          <div class="horizontal" v-for="(item, index) in iujp" :key="index">
            <div class="column5">
              <input
                class="modal-input-checkbox"
                type="checkbox"
                :id="index"
                :value="item.id"
                v-model="iujp[index]['checked']"
              />
            </div>
            <div class="column90 mr10">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="submit()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['label', 'storeName', 'modelName', 'mutationName', 'modalName'],
  data() {
    return {
      iujp: [],
      subData: [],
      subSearch: '',
    }
  },
  computed: {
    iujpData: async function() {
      const getIujp = await this.$getIujpNonInti()
      const defaultIujp = await this.$store.state[this.storeName][
        this.modelName
      ]

      let reduceIujp = await getIujp.reduce((a, b) => ({ ...a, [b.id]: b }), {})
      let reduceDefault =
        (await defaultIujp) &&
        defaultIujp.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceIujp, ...reduceDefault }

      let newIujp = await Object.values(combine)
      this.iujp = newIujp.sort((a, b) => this.$sortAsc(a, b))
      this.subData = newIujp.sort((a, b) => this.$sortAsc(a, b))
    },
  },
  methods: {
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subData

      let filteredList = []
      for (let i in list) {
        if (list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      this.iujp = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      // this.iujp = this.subData
      this.searchRun()
    },
    async submit() {
      await this.resetPlaceholder()

      let filterIujp = this.filteredIujp()
      await this.$store.commit(this.mutationName, {
        name: this.modelName,
        value: filterIujp,
      })
      await this.closeModal()
    },
    filteredIujp() {
      const filtered =
        this.iujp && this.iujp.filter(i => i.checked && i.checked == true)
      return filtered
    },
    closeModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: false,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
